
import Vue from 'vue';
import { Profile } from '@customer/types/customer';

interface Methods {
  openLoginModal: () => void;
  openSignupModal: () => void;
  logout: () => void;
}

interface Computed {
  isLoggedIn: boolean;
  getProfile: Profile | null;
}

export default Vue.extend<unknown, Methods, Computed, unknown>({
  computed: {
    isLoggedIn() {
      return this.$store.state.customer.isLoggedIn;
    },
    getProfile() {
      return this.$store.state.customer.profile;
    },
  },
  methods: {
    openLoginModal() {
      this.$store.commit('customer/setModalState', true);
    },
    openSignupModal() {
      this.$store.commit('customer/setLoginFormType', 'signup');
      this.$store.commit('customer/setModalState', true);
    },
    logout() {
      this.$store.dispatch('customer/logout');
    },
  },
  render() {
    const { isLoggedIn, getProfile } = this;
    const data = {
      isLoggedIn,
      profile: getProfile,
    };

    return this.$scopedSlots.default!({
      data,
      openLoginModal: this.openLoginModal,
      openSignupModal: this.openSignupModal,
      logout: this.logout,
    }) as any;
  },
});
